//import AWS from 'aws-sdk';
/*var params = {
    logEvents: [ 
    ],
    logGroupName: 'ClickEventGroup', 
    logStreamName: 'ButtonClick', 
  };		
var logParams ={
    "logGroupName": 'ClickEventGroup',
    "logStreamNamePrefix": 'ButtonClick', 
 };
var count = 0;
var con = {
    "accessKeyId" : "",
    "secretAccessKey":"",
    "region" : ""
};
var cloudwatchlogs;
var nextSequenceToken;
 
const createCloudWatchObject = () =>  {
    AWS.config.update(con)
    cloudwatchlogs = new AWS.CloudWatchLogs();
};

const getNextSequenceToken =  () => {
    return cloudwatchlogs.describeLogStreams(logParams, function (err, data) {
        if (err){ 
            console.log("DESCRIBE",err, err.stack);
        }else{
                  console.log("SEQUENCE TOKEN",data);
                  window.localStorage.setItem("st",data.logStreams[0].uploadSequenceToken);
        }
        nextSequenceToken = window.localStorage.getItem("st");
        return nextSequenceToken;
    });
};

const sendLogsToAws = () =>  {   
    if(params.logEvents.length > 0){
    getNextSequenceToken().on('success',(res) => {
        params.sequenceToken = res.data.logStreams[0].uploadSequenceToken;			  
        cloudwatchlogs.putLogEvents(params, (res) => {
            params.logEvents = [];
        });
      }).on('error',(err) => {
        console.log('Error while sending logs to aws : '+err);
      });
    }
};

const saveLogs = (message) =>  {
    console.log("savelogs");
    params.logEvents.push({
        "message": message,
        "timestamp": (new Date()).getTime()
    });
};

export {
    createCloudWatchObject,
    getNextSequenceToken,
    sendLogsToAws,
    saveLogs
};*/